import ReportListPage from './ReportListPage';

export default ReportListPage;
